<template>
  <div>
    <Breadcrumbs main="Ruta" title="Dibujar Rutas"/>
    <!-- Container-fluid starts-->
    <div class="container-fluid">
      <div class="row">
        <div class="col-md-12">
          <div class="card">
            <div class="card-header">
              <h5>
                Dibujar Rutas
              </h5>
            </div>
            <div class="card-body">
              <b-form class="needs-validation">
                <div class="form-row">
                  <div class="col-4 text-center">
                    <span class="badge badge-primary" style="font-size: 20px"><i class="fa fa-map-marker"> Total de despachos: {{totalMarkers}}</i></span>
                  </div>
                  <div class="col-4 text-center">
                    <span class="badge badge-warning" style="font-size: 20px"><i class="fa fa-map-marker"> Total de despachos disponibles: {{subtractDispatch}}</i></span>
                  </div>
                  <div class="col-4 text-center">
                    <span class="badge badge-success" style="font-size: 20px"><i class="fa fa-map-marker"> Total de despachos seleccionados: {{totalMarkerSelected}}</i></span>
                  </div>
                  <div class="col-12 mb-3 mt-3">
                    <div class="pull-left">
                      <b-button variant="danger" size="sm" v-show="!isDrawRoute && polygonsCount > 0" v-on:click="deleteLastRoute">
                        <i class="fa fa-times"></i> Eliminar la útlima ruta
                      </b-button>
                    </div>
                    <div class="pull-right">
                      <b-button variant="success" size="sm" v-show="!isDrawRoute && polygonsCount < colors.length" v-on:click="drawRoute">
                        <i class="fa fa-map-marker"></i> Agregar ruta
                      </b-button>
                      <b-button class="mr-2" variant="warning" size="sm" v-show="isDrawRoute && polygonsCount < colors.length" v-on:click="drawRoute">
                        <i class="fa fa-map-marker"></i> Finalizar ruta
                      </b-button>
                      <b-button variant="danger" size="sm" v-show="isDrawRoute && polylines[polygonsCount].path.length" v-on:click="deleteLastPoint">
                        <i class="fa fa-times"></i> Eliminar el último punto
                      </b-button>
                    </div>
                  </div>

                  <div class="col-md-12 mb-3">
                    <gmap-map style="width: 100%; height: 500px" ref="map"
                              :center="optionsMap.center"
                              :zoom="optionsMap.zoom"
                              @click="addPolyline"
                    >
                      <gmap-polygon v-for="polygon in polylines" :path="polygon.path" :editable="true"  ref="polyline" :options="polygon.options" :key="polygon"></gmap-polygon>
                      <!--                      <gmap-custom-marker v-for="mark in marker" :position="mark">-->
                      <!--                      </gmap-custom-marker>-->
                      <gmap-custom-marker v-for="mark in markers" :marker="mark">
                        <img src="../../../assets/images/google-maps-marker-red.png" alt="posición" width="25px" height="40px"/>
                        <!--                        '../../../assets/icon_markers/' + -->
                      </gmap-custom-marker>
                    </gmap-map>
                  </div>
                </div>
              </b-form>
              <div class="row mb-3" v-for="form in forms">
                <div class="col-2">
                  <button type="button" class="btn m-t-15" v-bind:style="{'background-color': form.color, 'border-color': form.color, 'color': '#fff'}"><i class="fa fa-map-marker"></i>
                    {{form.routetrajectory_set.length}} entrega(s)</button>
                </div>
                <div class="col-2">
                  <button type="button" class="btn btn-primary m-t-15" v-on:click="displayModalInfoDispatch(form)"><i class="fa fa-info"></i> Ver Despacho(s)</button>
                </div>
                <div class="col-4">
                  <label>Vehículo (requerido)</label>
                  <multiselect placeholder="Selecciona un vehículo"
                               label="full_name" track-by="id"
                               deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                               v-model="form.vehicle.value" :options="form.vehicle.options"
                               @input="freeLastSelected('vehicle', form.vehicle)"
                               @select="setLastRowSelected(form)"
                               :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
                    <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                  </multiselect>
                  <b-form-invalid-feedback :state="form.vehicle.is_valid">{{form.vehicle.message_error}}</b-form-invalid-feedback>
                </div>
                <div class="col-4">
                  <label>Conductor (requerido)</label>
                  <multiselect placeholder="Selecciona un conductor" id="type_id"
                               label="full_name" track-by="id"
                               deselectLabel="Click para eliminar" selectLabel="Seleccionar"
                               v-model="form.worker.value" :options="form.worker.options"
                               @input="freeLastSelected('worker', form.worker)"
                               @select="setLastRowSelected(form)"
                               :searchable="true" :close-on-select="true" :show-labels="true" :allow-empty="false">
                    <template slot="noResult">No se encontraron elementos, por favor, cambie el filtro de búsqueda.</template>
                  </multiselect>
                  <b-form-invalid-feedback :state="form.worker.is_valid">{{form.worker.message_error}}</b-form-invalid-feedback>
                </div>
              </div>
              <b-button type="button" variant="success" @click="onSubmit" v-if="forms.length > 0">Agregar Ruta</b-button>
              <b-button type="button" variant="warning" class="ml-1" :to="{'name': 'RouteList'}">Volver</b-button>
            </div>
          </div>
        </div>
      </div>
    </div>
    <b-modal id="info-dispatch" centered size="lg" title="Despachos de la ruta" ok-title="Cerrar" ok-only class="theme-modal">
      <b-row>
        <b-col md="12">
          <b-input-group class="datatable-btn">
            <b-form-input v-model="datatableOptions.filter" placeholder="Buscar..."></b-form-input>
          </b-input-group>
        </b-col>
      </b-row>
      <div class="table-responsive datatable-vue">
        <b-table
                show-empty
                stacked="md"
                :items="datatableOptions.items"
                :fields="datatableOptions.tablefields"
                :filter="datatableOptions.filter"
                :current-page="datatableOptions.currentPage"
                :per-page="datatableOptions.perPage"
                @filtered="onFiltered"
        >
          <template v-slot:cell(client)="data">
            {{data.item.client.business_name}}
          </template>
          <template v-slot:cell(dispatch_client)="data">
            {{data.item.name}}
          </template>
          <template v-slot:cell(phone)="data">
            <span v-if="data.item.phone">{{data.item.phone}}</span>
            <span v-else>No proporcionado.</span>
          </template>
        </b-table>
      </div>

      <b-col md="6" class="my-1">
        <b-pagination
                v-model="datatableOptions.currentPage"
                :total-rows="datatableOptions.totalRows"
                :per-page="datatableOptions.perPage"
                class="my-0"
        ></b-pagination>
      </b-col>
    </b-modal>
    <!-- Container-fluid Ends-->
  </div>
</template>

<script>
  import axios from 'axios';
  import Multiselect from 'vue-multiselect';
  import GmapCustomMarker from 'vue2-gmap-custom-marker';
  import pointInPolygon from 'point-in-polygon'
  import utils from '../../../utils';

  export default {
    components: {
      Multiselect,
      GmapCustomMarker
    },
    data(){
      return {
        //  TOTAL DE MARCADORES
        totalMarkers: 0,
        // TOTAL MARCADORES SELCCIONADOS
        totalMarkerSelected: 0,
        // MÁXIMO A SELECCIONAR
        markSelectedError: 0,
        // PARA SABER SI ES´TA DIBUJANDO
        isDrawRoute: false,
        // COLORES DE LOS POLÍGONOS Y MARCADORES
        colors: [
          '#FF974C', '#FFD700', '#FFC915',
          '#7FFF00', '#008000', '#808000',
          '#66CDAA', '#00CED1', '#008080',
          '#00BFFF', '#0000FF', '#483D8B',
          '#FF00FF', '#9400D3', '#4B0082',
          '#FFB6C1', '#FF1493', '#C71585',
        ],
        // DONDE GUARDARÉ LOS TRABAJADORES DISPONIBLES
        workerField: utils.defaultFields({_type: 'select'}),
        vehicleField: utils.defaultFields({_type: 'select'}),
        // GUARDARÉ LO ÚTLIMO SELECCIONADO
        lastVehicleSelected: null,
        lastWorkerSelected: null,
        // CONTADOR ACTUAL DE POLÍGONOS
        polygonsCount: 0,
        optionsMap: {
          center: {lat: -33.4488897, lng: -70.6692655},
          zoom: 12,
        },
        markers: [],
        polylines: [],
        forms: [],
        datatableOptions: {
          tablefields: [
            { key: 'code', label: 'Código', sortable: true},
            { key: 'tracking_code', label: 'Código de seguimiento', sortable: true},
            { key: 'client', label: 'Cliente', sortable: true},
            { key: 'dispatch_client', label: 'Cliente a despacho', sortable: true},
            { key: 'phone', label: 'Teléfono', sortable: true},
            { key: 'address', label: 'Dirección', sortable: true},
          ],
          items: null,
          filter: null,
          totalRows: 1,
          currentPage: 1,
          perPage: 10,
        }
      }
    },
    async mounted () {
      // OBTENGO LOS DESPACHOS
      await this.getDispatch(this.markers);
      // OBTENGO LOS TRABAJADORES
      this.getWorker(this.workerField);
      // OBTENGO A LOS VEHÍCULOS
      this.getVehicle(this.vehicleField);
      // OBTENGO EL TOTAL DE MARCADORES
      this.totalMarkers = this.markers.length;
    },
    methods: {
      onSubmit(evt){
        // console.log(evt)
        evt.preventDefault();
        // RECORRO CADA FORMULARIO
        let data = [];
        let is_valid = true;
        this.forms.forEach((form) => {
          // DATA PARA CADA DICCIONARIO
          let _data = {};
          // GENERAMOS UNA COPIA DEL FORM
          const _form = Object.assign({}, form);
          // ELIMINAMOS LA LLAVE COLOR Y LISTA DE DESPACHOS
          delete _form['color'];
          delete _form['dispatchsList'];
          // VEO SI ES VÁLIDO
          is_valid = is_valid && utils.generateJsonStructure(_form, _data);
          // LO AGREGAMOS A LA DATA
          data.push(_data)
        });
        if(is_valid){
          this.$swal({
            title: 'Información',
            type: 'info',
            html: `Estás a punto de agregar una(s) ruta(s). Al agregar <b>bloquearás</b> a los conductores con su vehículo, en donde, no podrán ser utilizados hasta que no se haya finalizado/eliminado/detenido la ruta.`,
            showCloseButton: true,
            showCancelButton: true,
            focusConfirm: false,
            confirmButtonColor: '#28a745',
            confirmButtonText: '<i class="fa fa-thumbs-up"></i> Continuar',
            cancelButtonColor: '#dc3545',
            cancelButtonText: '<i class="fa fa-thumbs-down"></i> Cancelar',
            showLoaderOnConfirm: true,
            preConfirm: async () => {
              const path = '/api/route/v1.0/route/';
              await axios.post(path, data).then(async () => {
                // console.log(response);
                await this.$swal({
                  title: 'Agregado',
                  type: 'success',
                  html: `Se han agregado la(s) ruta(s) de manera correcta.`,
                }).then(() => {
                  this.$router.push({'name': 'RouteList'});
                });
              }).catch(async (error) => {
                // ERROR 401 DA CUANDO NO SE ENVÍA EL TOKEN
                console.log(error.response);
                if(error.response.status === 400){
                  utils.generateBackendError(this.form, error.response.data);
                  await this.$swal({
                    title: 'Error',
                    type: 'error',
                    html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
                  });
                }
              });
            }
          });
        } else {
          this.$swal({
            title: 'Error',
            type: 'error',
            html: `Hay campos que no han sido completados correctamente, por favor, verifica nuevamente el formulario.`,
          });
        }
      },
      addPolyline (point){
        if(this.isDrawRoute){
          this.polylines[this.polygonsCount].path.push(
              {
                'lat': point.latLng.lat(),
                'lng': point.latLng.lng(),
              }
          )
        }
      },
      async drawRoute(){
        // SI ES QUE ESTOY DIBUJANDO, AGREGO UN NUEVO POLÍGONO
        if(!this.isDrawRoute){
          // CAMBIO EL BOTON AFINALIZAR POLÍGONO O ACTIVAR EL POLÍGNO
          this.isDrawRoute = !this.isDrawRoute;
          // AGREGO UN NUEVO POLÍGONO A LOS POLYLINES
          this.polylines.push(
              {
                path: [],
                markers: [],
                options: {
                  strokeColor: this.colors[this.polygonsCount],
                  editable: false,

                }
              }
          );
        }else{
          // VALIDO QUE EL POLÍGONO SEA VÁLIDO Y TENGA 3 PUNTOS COMO MÍNIMO
          if(this.polylines[this.polygonsCount].path.length >= 3 ){
            this.markSelectedError = await this.getTotalSelectedPoints(this.polylines[this.polygonsCount]);
            if (this.markSelectedError > utils.maxDispatch) {
              this.$swal({
              title: 'Información',
              type: 'info',
              html: `No se ha podido agregar la ruta, debido a que tienes <b>${this.markSelectedError}</b> despachos seleccionados y se pueden utilizar como máximo <b>${utils.maxDispatch}</b>.`,
            });
              return;
            }
            // EDITO LAS OPCIONES DEL POLÍGNO PARA QUE NO LO PUEDA EDITAR
            this.polylines[this.polygonsCount].options['editable'] = false;
            // OBTENGO EL FORMULARIO A AGREGAR
            let form = {
              color: this.colors[this.polygonsCount],
              worker: Object.assign({}, this.workerField),
              vehicle: Object.assign({}, this.vehicleField),
              routetrajectory_set: [],
              dispatchsList: []
            };
            // GENERO UNA LISTA DE LOS INPUTS DE LOS VEHÍCULOS
            let vehiclesFields = [];
            // GENERO UNA LISTA DE LOS INPUTS DE LOS TRABAJADORES
            let workersFields = [];
            // BUSCO TODOS LOS INPUTS DE VEHÍCULOS
            this.forms.forEach(item => vehiclesFields.push(item['vehicle']));
            // BUSCO TODOS LOS INPUTS DE LOS TRABAJADORES
            this.forms.forEach(item => workersFields.push(item['worker']));
            // CAMBIO LAS OPCIONES DISPONIBLES PARA EL VEHÍCULO
            form.vehicle.options = this.setAvailableOptions(this.vehicleField, vehiclesFields);
            // CAMBIO LAS OPCIONES DISPONIBLES PARA EL TREABAJADOR
            form.worker.options = this.setAvailableOptions(this.workerField, workersFields);
            // OBTENEMOS EL COLOR DEL POLÍGNO
            const color = this.colors[this.polygonsCount].replace('#', '');
            // EJECUTO LA FUNCIÓN QUE CAMBIA DE COLOR LOS MARCADORES QUE SE ENCUENTRAN EN EL POLÍGNO
            await this.pointInPolygonComputed(this.polylines[this.polygonsCount], color);
            // AGREGO LAS ID DEL DESPACHO AL FORMULARIO
            this.polylines[this.polygonsCount].markers.forEach((item) => {
              form.dispatchsList.push(
                  item
              );
              form.routetrajectory_set.push(
                  {
                    dispatch: utils.defaultFields(
                        {
                          value: item['id']
                        }
                    )
                  }
              )
            });
            // AUMENTO EL NÚMERO DE POLÍGNONOS
            this.polygonsCount++;
            // GENERAMOS UN NUEVO FORMULARIO
            this.forms.push(
                form
            );
            // CAMBIO EL BOTON AFINALIZAR POLÍGONO O ACTIVAR EL POLÍGNO
            this.isDrawRoute = !this.isDrawRoute;
          } else {
            // GENERO UNA ALERTA QUE NECESITAMOS COMO MÍNIMO 3 PUNTOS
            this.$swal({
              title: 'Información',
              type: 'info',
              html: `No se ha podido agregar la ruta, debido a que se necesitan como mínimo <b>3</b> puntos.`,
            });
          }
        }
      },
      deleteLastPoint(){
        this.polylines[this.polygonsCount].path.pop();
      },
      deleteLastRoute(){
        // OBTENGO EL ÚLTIMO POLIGONO CREADO
        const pointPolygons = this.polylines.pop();
        // ELIMINAMOS EL ÚLTIMO FORMULARIO
        const form  = this.forms.pop();
        // CAMBIAMOS DE COLOR A LOS MARCADORES
        for(let i = 0; i < pointPolygons.markers.length; i++){
          pointPolygons.markers[i]['color'] = 'FF0000';
          // DISMINUYO EL NÚMERO DE MARCADORES SELECICONADOS
          this.totalMarkerSelected--;
        }
        this.freeOption(form.vehicle, 'vehicle');
        this.freeOption(form.worker, 'worker');
        // DISMINUYO EL NÚMERO DE POLÍGNONOS
        this.polygonsCount--;
      },
      getColor(color){
        return require(`../../../assets/icon_markers/${color}.png`);
      },
      async pointInPolygonComputed(polygon, color){
        // GENERO UNA LISTA PARA GUARDAR EL POLÍGONO [[LAT, LNG]...]
        let polygonPoint = [];
        // VOY COLOCANDO LOS VALORES A LA LISTA
        polygon.path.forEach(item => polygonPoint.push([item['lat'], item['lng']]));
        for(let i = 0; i < this.markers.length; i++){
          // SI ES ROJO, ES PORQ NO HA SIDO ASIGNADO
          if(this.markers[i]['color'] === 'FF0000'){
            // VEO SI ESTÁ DENTRO DEL POLÍGNO
            if(pointInPolygon([this.markers[i]['lat'], this.markers[i]['lng']], polygonPoint)){
              // CAMBIO EL COLOR
              this.markers[i]['color'] = color;
              // AGREGO LOS MARCADORES AL POLÍGONO
              polygon.markers.push(
                  this.markers[i]
              );
              // AUMENTO EL NÚMERO DE MARCADORES SELECICONADOS
              this.totalMarkerSelected++;
            }
          }
        }
      },
      async getTotalSelectedPoints(polygon) {
         // GENERO UNA LISTA PARA GUARDAR EL POLÍGONO [[LAT, LNG]...]
        let polygonPoint = [];
        let count = 0;
        // VOY COLOCANDO LOS VALORES A LA LISTA
        polygon.path.forEach(item => polygonPoint.push([item['lat'], item['lng']]));
        for(let i = 0; i < this.markers.length; i++){
          // SI ES ROJO, ES PORQ NO HA SIDO ASIGNADO
          if(this.markers[i]['color'] === 'FF0000'){
            // VEO SI ESTÁ DENTRO DEL POLÍGNO
            if(pointInPolygon([this.markers[i]['lat'], this.markers[i]['lng']], polygonPoint)){
              // AUMENTO EL NÚMERO DE MARCADORES SELECICONADOS
              count++;
            }
          }
        }
        return count;
      },
      async getDispatch(markersList){
        const path = `/api/inventory/v1.0/dispatch/`;
        const config = {
          params: {
            status__in: utils.drawStatusRoute
          }
        };
        await axios.get(path, config).then(async (response) => {
          // response.data.forEach(item => markersList.push({lat: item['lat'], lng: item['lng'], color: 'FF0000'}));
          response.data.forEach((item) => {
            item['color'] = 'FF0000';
            markersList.push(item);
          });
          markersList = response.data;
        }).catch((error) => {
          console.log(error.response);
        });
      },
      getWorker(workerField){
        const path = `/api/core/v1.0/worker_profile/`;
        const config = {
          params: {
            user__is_active: true,
            available: true
          }
        };
        axios.get(path, config).then(async (response) => {
          workerField.options = response.data;
        }).catch((error) => {
          console.log(error.response);
        });
      },
      getVehicle(vehicleField){
        const path = `/api/route/v1.0/vehicle/`;
        const config = {
          params: {
            available: true
          }
        };
        axios.get(path, config).then(async (response) => {
          vehicleField.options = response.data;
        }).catch((error) => {
          console.log(error.response);
        });
      },
      setAvailableOptions(inputEdit, inputSelected){
        // GENERO UNA LISTA CON TODAS LAS OPCIONES SELECCIONADAS
        let valuesSelected = [];
        // NUEVAS OPCIONES
        let newOptions = [];
        // RECORRO LOS INPUTS SELECCIOANDOS
        inputSelected.forEach(function (item) {
          if(item.value !== ''){
            // GUARDO LA ID SELECCIONADA
            valuesSelected.push(
                item.value['id']
            );
          }
        });
        // RECORRO SUS OPCIONES Y SELECCIONO LAS QUE NO ESTÁ SELECCIONADAS POR OTROS INPUTS
        inputEdit.options.forEach(function (item) {
          if(!valuesSelected.includes(item['id'])){
            // GUARDO LA OPCIÓN
            newOptions.push(
                item
            );
          }
        });
        // RETORNO LAS OPCIONES
        return newOptions;
      },
      freeOption(inputRemove, inputType){
        // LISTA DE LOS INPUTS
        let inputSelected = [];
        // TRAIGO TODOS LOS INPUTS
        this.forms.forEach(item => inputSelected.push(item[inputType]));
        if(inputRemove.value !== '' && inputRemove.value !== null){
          inputSelected.forEach(item => item.options.push(inputRemove.value));
        }
      },
      freeLastSelected(type, newValue){
        // BUSCO EL ELEMENTO DESELECCIONADO
        const itemSelected = (type === 'vehicle') ?
            this.vehicleField.options.find(item => item['id'] === this.lastVehicleSelected) :
            this.workerField.options.find(item => item['id'] === this.lastWorkerSelected);
        // RECORRO CADA INPUT SEGÚN EL TIPÓ PARA LIBERAR SU ÚLTIMA OPCIÓN
        this.forms.forEach((item) => {
          // SI SON DISTINTOS, ENTONCES ESTOY EN LOS INPUTS DISTINTO AL QUE SE CAMBIÓ
          if(newValue['value']['id'] !== item[type]['value']['id']){
            // ELIMINO LA OPCIÓN SELECCIONADA DE TODOS LOS SELECT
            // INDEX DEL ELEMENTO A E LIMINAR
            const index = item[type].options.findIndex(_item => _item['id'] === newValue['value']['id']);
            // ELEMENT
            // ELIMINAMSO EL ELEMENTO
            item[type].options.splice(index, 1);
            // AGREGO AL OPCIÓN DESELECCIONADA AL SELECT
            if(itemSelected !== undefined) item[type].options.push(itemSelected);
          }
        });
        // NECESITAMOS ELIMINAR LA OPCIÓN SELECCIONADA
      },
      setLastRowSelected(lastRow){
        this.lastVehicleSelected = lastRow['vehicle'].value['id'];
        this.lastWorkerSelected = lastRow['worker'].value['id'];
      },
      displayModalInfoDispatch(form){
        this.datatableOptions.totalRows = form['dispatchsList'].length;
        this.datatableOptions.items = form['dispatchsList'];
        this.$bvModal.show('info-dispatch');
      },
      onFiltered(filteredItems) {
        // Trigger pagination to update the number of buttons/pages due to filtering
        this.datatableOptions.totalRows = filteredItems.length;
        this.datatableOptions.currentPage = 1
      },
    },
    computed: {
      subtractDispatch() {
        return this.totalMarkers - this.totalMarkerSelected;
      }
    }
  }
</script>

<style>
  .badge-warning {
    color: #ffffff !important;
    background-color: #ffc107;
  }
</style>